import LayoutPrimary from '../../layouts/Primary';
import FontPairingIndex from '../../views/Admin/Config/FontPairing/FontPairingIndex';
import FontPairingEdit from '../../views/Admin/Config/FontPairing/FontPairingEdit';
import FontPairingCreate from '../../views/Admin/Config/FontPairing/FontPairingCreate';

export default [
    {
        path: '/font-pairing/create',
        name: 'FontPairingCreate',
        component: FontPairingCreate,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/font-pairing/index',
        name: 'FontPairingIndex',
        component: FontPairingIndex,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
        props: true,
    },
    {
        path: '/font-pairing/edit/:id',
        name: 'FontPairingEdit',
        component: FontPairingEdit,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
];
